import  * as React from "react";
import { observer } from "mobx-react";
import { IHighlightedResultsDetailsParams } from "./IHighlightedResultsDetailsParams";
import { ICloseButtonParams } from "./../CloseButton/ICloseButtonParams";
import { CloseButton } from "./../CloseButton/CloseButton";
import { IReportMeasurement} from "Data";

@observer
export class HighlightedResultsDetails extends React.Component<IHighlightedResultsDetailsParams>{
    constructor(props: IHighlightedResultsDetailsParams) {
        super(props, undefined);
        
    }
    checkStrokeIndex(stroke: IReportMeasurement): number {
        if (this.props.selectedGroupOfStrokes && this.props.selectedGroupOfStrokes.strokes) {
            if(this.props.selectedStroke){
                return this.props.selectedGroupOfStrokes.strokes.indexOf(this.props.selectedStroke) + 1;
            }            
        }
        return 1; // added by jfe
    }
    private getCloseButtonDetailsParams() {
        const result: ICloseButtonParams = {
            selectedGroupOfStrokes: this.props.selectedGroupOfStrokes,
            cleanSelectedShot: this.props.cleanSelectedShot
        };
        return result;
    }

    render() {
        let ballIconStyle = {
            background: this.props.selectedGroupOfStrokes && this.props.selectedGroupOfStrokes.color
        }

        return <div className="HighlightedResultsDetails">
            {this.props.selectedGroupOfStrokes && this.props.selectedStroke && this.props.selectedAverage == null &&
                   <div className="text-above-row-with-tiles-filled-with-data">
                       <div className="ball-icon-and-shot-number">
                           <div className="ball-icon above-row" style={ballIconStyle}>
                               <img src="Images/MultiShotControl/single-shot-icon-without-border.png" alt="Ball icon" />
                           </div>
                    <span className="shot-number"><span>#</span><span>{this.checkStrokeIndex(this.props.selectedStroke)}</span></span>
                       </div>
                       <CloseButton {...this.getCloseButtonDetailsParams() }></CloseButton>
                </div>
            }
            {this.props.selectedGroupOfStrokes && this.props.selectedAverage != null &&
                <div className="text-above-row-with-tiles-filled-with-data  hidden-print">
                    <div className="multiple-balls-icon">
                        <img src="Images/MultiShotControl/average-icon.svg" alt="Ball icon" /><span>Average</span>
                    </div>
                    <CloseButton {...this.getCloseButtonDetailsParams()}></CloseButton>
                </div>
            }
               {this.props.selectedStroke == null && this.props.selectedAverage == null &&
                    <div className="text-above-row-with-empty-tiles  hidden-print">
                        <span>Click a Shot or Average below to see data here</span>
                    </div>
                    }
        </div >;
    }
}
